import PropTypes from 'prop-types'
import React from 'react'
import { ReactComponent as SvgIcon } from './ImagePolaroid.svg'
import BaseIcon from '../../BaseIcon'

const ImagePolaroid = ({ className }) => {
	return <BaseIcon component={SvgIcon} className={className} viewBox="0 0 39 39" />
}
ImagePolaroid.propTypes = {
	className: PropTypes.string,
}

export default ImagePolaroid
